export const kStandardDeviationClass = "standard-deviation"
export const kStandardDeviationType = "Standard Deviation"
export const kStandardDeviationPrefix = "ADRN"
export const kStandardDeviationLabelKey = "DG.Inspector.graphPlottedStDev"
export const kStandardDeviationUndoAddKey = "DG.Undo.graph.showPlottedStDev"
export const kStandardDeviationRedoAddKey = "DG.Redo.graph.showPlottedStDev"
export const kStandardDeviationUndoRemoveKey = "DG.Undo.graph.hidePlottedStDev"
export const kStandardDeviationRedoRemoveKey = "DG.Redo.graph.hidePlottedStDev"
export const kStandardDeviationValueTitleKey = "DG.PlottedAverageAdornment.stDevValueTitle"
